'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var DivVisibilityContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var hide = _a.hide;
    return hide && 'display: none;';
});
var templateObject_1;

exports.DivVisibilityContainer = DivVisibilityContainer;
